module.exports = __webpack_public_path__ + "img/banner2025_pc.4e291f04.jpg";